export default __webpack_public_path__ + "static/media/banner.79e687d0.jpg";